import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { isPriviliged } from '../../../core/deviceHelper';
import { intlShape, injectIntl, FormattedMessage } from 'react-intl';
import s from '../Popup.css';
import { 
	setDeviceCommandValue,
	removeProtectedInstallation, 
	getDeviceInfo 
} from '../../../actions/device';
import Messages from '../Messages';
import Icon from '../../Icon';
import Loader from '../../Loader';
import ConnectedDevicesCommon from './ConnectedDevicesCommon';
import {concatenateLists} from './utils';

class ConnectedDevicesSafeTechXSafeFloor extends ConnectedDevicesCommon {

	deleteDevice = (installation_id, deviceId) => {
		this.props.setDeviceCommandValue(this.props.serial, `setFSR`, deviceId);
		if (installation_id){
			this.props.removeProtectedInstallation(installation_id, deviceId);
			this.props.getDeviceInfo(this.props.serial, 'safetech');
		}
	}



	render() {
		const { device, userRole } = this.props;
		const messages = Messages();
		const liveData = device.get('live');
		const info = device.get('info');
		const { getFSL } = liveData;

		if (info !== null && 'safefloor_protection' in info){
			const safefloor_protection = info['safefloor_protection']
			const connectedSafeFloors = getFSL != undefined ? JSON.parse(getFSL) : []
			const cl = concatenateLists(safefloor_protection, connectedSafeFloors)	
			return (
			  <div>
			    <FormattedMessage {...messages.pairing_already_connected_list_text} />
			    <ul>
			      {cl.map((item, index) => this.showText(item, userRole))}
			    </ul>
			    {cl.length > 0 ? (
			    	<div>
					    <div className={s.green_text}>
					    	<FormattedMessage {...messages.pairing_paired_on_device_and_service} />
					    </div>
					    <div className={s.orange_text}>
					    	<FormattedMessage {...messages.pairing_paired_on_service} />
					    </div>
					    <div className={s.red_text}>
					    	<FormattedMessage {...messages.pairing_paired_on_device} />
					    </div>
				    </div>
			    ) : null}
			  </div>
			)		



		} else {
	        return (
	          <div>
	            <Loader block />
	          </div>
	        )
		}
	}
}



ConnectedDevicesSafeTechXSafeFloor.propTypes = {
  userRole: PropTypes.string.isRequired,
  setDeviceCommandValue: PropTypes.func.isRequired,
  device: PropTypes.object.isRequired,
  serial: PropTypes.string.isRequired
};


const mapDispatch = dispatch => {
  return {
    setDeviceCommandValue: (deviceId, command, value) => 
      dispatch(setDeviceCommandValue(deviceId, command, value)),
    removeProtectedInstallation:(installation_id, action) => 
      dispatch(removeProtectedInstallation(installation_id, action)),
    getDeviceInfo: (deviceId, deviceType) =>
      dispatch(getDeviceInfo(deviceId, deviceType)),
  };
};

export default injectIntl(
  compose(connect(null, mapDispatch), withStyles(s))
  (ConnectedDevicesSafeTechXSafeFloor)
);



// WEBPACK FOOTER //
// ./src/components/Popup/DevicePopups/ConnectedDevicesSafeTechXSafeFloor.js